module.exports = __webpack_public_path__ + "static/cheese-pudding-b79d81d163a2aaaf242733f857fa4c0b.jpg";